var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-page-container"},[_c('Spinner',{attrs:{"id":'loaderPage'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }